import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Routes from "./routes";
import FAuth from "./Auth/FAuth";
import PraviteRoute from "./Auth/PrivateRoute";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import loginIn from "./components/LoginIn/LoginIn";

ReactDOM.render(
 <Routes />,
  document.getElementById("root")
);


// {/* <FAuth>
// <BrowserRouter>
//   <Switch>
//     <PraviteRoute exact path="/" component={Routes}></PraviteRoute>
//     <Route exact path="/login" component={loginIn}></Route>
//   </Switch>
// </BrowserRouter>
// </FAuth>, */}